export default "__VITE_ASSET__BVq07DB4__"